module.exports = __webpack_public_path__ + "img/action_elimina.d5fd5fef.svg";